import { render, staticRenderFns } from "./home_new.vue?vue&type=template&id=46124e83&scoped=true&"
import script from "./home_new.vue?vue&type=script&lang=ts&"
export * from "./home_new.vue?vue&type=script&lang=ts&"
import style0 from "./home_new.vue?vue&type=style&index=0&id=46124e83&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46124e83",
  null
  
)

export default component.exports